// extracted by mini-css-extract-plugin
module.exports = {"removeIconForKidsList":"Bi","removeIcon":"Bj z0"};